import React from "react";
import { useField } from "formik";
import { Form, Label } from "semantic-ui-react";

interface Props {
  placeholder: string;
  name: string;
  label?: string;
  rows: number;
  autoComplete?: string;
  disabled:boolean;
}

export default function CustomTextAreaInput(props: Props) {
  const [field, meta] = useField(props.name);
  return (
    <>
      <Form.Field error={meta.touched && !!meta.error}>
        <textarea {...field} {...props} />
        {meta.touched && meta.error ? (
          <Label basic color="red">
            {meta.error}
          </Label>
        ) : null}
      </Form.Field>
    </>
  );
}
